import { render, staticRenderFns } from "./AdvisorTopMenu.vue?vue&type=template&id=73135ca1&scoped=true"
import script from "./AdvisorTopMenu.vue?vue&type=script&lang=js"
export * from "./AdvisorTopMenu.vue?vue&type=script&lang=js"
import style0 from "./AdvisorTopMenu.vue?vue&type=style&index=0&id=73135ca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73135ca1",
  null
  
)

export default component.exports